import type { DefaultPaginatedFilters } from "@/api/shared/filters";
import type { TAddress } from "@/api/shared/address";

export interface TReferralSearchFilters extends DefaultPaginatedFilters {
  patient?: string;
  patient__in?: string[];
  practice_from?: string;
  practice_from__in?: string[];
  practice_to?: string;
  practice_to__in?: string[];
  status?: EReferralStatus;
  status__in?: EReferralStatus[];
}

export enum EReferralStatus {
  NEW = "new",
  ACCEPTED = "accepted",
  REJECTED = "rejected",
}

export interface TReferral {
  id?: string;
  patient?: string | TReferralPatientListItem;
  treatment_job?: string;
  practice_from?: string | TReferralPracticeListItem;
  practice_to?: string | TReferralPracticeListItem;
  created_at?: Date | string;
  accepted_at?: string | null;
  status?: EReferralStatus;
  status_changed_at?: string | null;
  staff_created_by?: string | TReferralStaffListItem;
  price_for_referral?: number | null;
  price_for_referral_items?: unknown | null;
  listed_price_for_referral?: number | null;
  listed_price_for_referral_items?: TReferralItem | null;
}

/** A staff/user reference embedded on a history row. Mirrors `THistoryUser` in `terms/terms/types.ts`. */
export type TReferralHistoryUser = {
  id: string;
  staff: {
    id: string;
    first_name: string;
    last_name: string;
  } | null;
};

/** A django-simple-history audit row for a referral (`GET /referral/{id}/history/`). */
export type TReferralHistoryEntry = TReferral & {
  history_id: number;
  history_date: string;
  history_type: "+" | "~" | "-";
  history_user: string | null | TReferralHistoryUser;
};

export interface TReferralItem {
  name: string;
  total_price: number;
  per_file_quantity: number | null;
  is_fee: boolean;
}

export interface TReferralPatientListItem {
  id: string;
  first_name?: string;
  last_name?: string;
}

export type TReferralPracticeAddress = TAddress & { primary?: boolean };

export interface TReferralPracticeListItem {
  id: string;
  name: string;
  addresses?: TReferralPracticeAddress[];
}

export interface TReferralStaffListItem {
  id: string;
  first_name?: string;
  last_name?: string;
}

export interface TReferralCreatePayload {
  practice_to: string;
}
